<section class="authenticator-app-links" [class.authenticator-app-links--compact]="compact">
    <div class="authenticator-app-links__icon" aria-hidden="true">
        <fa-icon [icon]="['fal', 'mobile-alt']"></fa-icon>
    </div>

    <div class="authenticator-app-links__content">
        <div class="authenticator-app-links__heading">
            <strong>Google Authenticator</strong>
            <span *ngIf="!compact">{{ 'SECURITY.TWO_FACTOR.SETUP.STEP1' | translate }}</span>
        </div>

        <div class="authenticator-app-links__actions">
            <a
                class="authenticator-app-links__store"
                href="https://apps.apple.com/us/app/google-authenticator/id388497605"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Google Authenticator - App Store">
                <fa-icon [icon]="['fal', 'download']" aria-hidden="true"></fa-icon>
                <span>App Store</span>
                <fa-icon class="authenticator-app-links__external" [icon]="['fal', 'external-link-alt']" aria-hidden="true"></fa-icon>
            </a>

            <a
                class="authenticator-app-links__store"
                href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Google Authenticator - Google Play">
                <fa-icon [icon]="['fal', 'download']" aria-hidden="true"></fa-icon>
                <span>Google Play</span>
                <fa-icon class="authenticator-app-links__external" [icon]="['fal', 'external-link-alt']" aria-hidden="true"></fa-icon>
            </a>

            <a
                class="authenticator-app-links__help"
                href="https://support.google.com/accounts/answer/1066447"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Google Authenticator Help">
                <fa-icon [icon]="['fal', 'info-circle']" aria-hidden="true"></fa-icon>
                <span>Google Help</span>
            </a>
        </div>
    </div>
</section>
